import snackbar, { type SnackbarMessage } from '@@containers/Snackbar';

type SnackbarError = {
    message: SnackbarMessage;
    title?: string;
    code?: string;
};

export const showErrorMessage = (error: SnackbarError) =>
    snackbar.error(error.message, { title: error.title || error.code });
